// Globals
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Models
import { IFilter } from '@/models/filters.model';
import { ROUTES } from '@/models/router.model';

// Components
import { StyledActionsWrap, StyledButton } from './FilterTableActionsStyles';
import { EditIcon, EyeIcon, TrashIcon } from '@/icons';
import { StyledActionButton } from '@/components';

// Helpers
import { COLORS } from '@/theme';

type TFilterTableActions = {
  record: IFilter;
  canManage: boolean;
  onEdit: (filter: IFilter) => void;
  onDelete: (filter: IFilter) => void;
};

const FilterTableActions = ({ record, canManage, onEdit, onDelete }: TFilterTableActions) => {
  const { t } = useTranslation(['categories']);
  const navigate = useNavigate();

  const handleViewValues = () => {
    navigate(`${ROUTES.CATEGORY_FILTERS}/${record.id}`);
  };

  return (
    <StyledActionsWrap>
      {canManage && (
        <>
          <StyledActionButton onClick={() => onEdit(record)} $color={COLORS.PALE_YELLOW}>
            <EditIcon />
          </StyledActionButton>
          <StyledActionButton $color={COLORS.RED} onClick={() => onDelete(record)}>
            <TrashIcon />
          </StyledActionButton>
        </>
      )}

      <StyledButton icon={<EyeIcon />} onClick={handleViewValues}>
        {t('view_filter_values')}
      </StyledButton>
    </StyledActionsWrap>
  );
};

export default FilterTableActions;
